import React, { useEffect, useState } from "react";
import "./tax.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/footer/main";

const Taxcal = () => {
  const [value, setvalue] = useState(350000);
  const [tax, setTax] = useState(17500);
  const [income, setIncome] = useState(332500);
  const [daysvalue, setDaysvalue] = useState(18);

  const generateTax = (salary) => {
    let tax = 0;
    if (salary < 250001) {
      return tax;
    } else if (salary > 250000 && salary < 500000) {
      tax = 0.05 * salary;
      return tax;
    } else if (salary >= 500000 && salary < 1000000) {
      tax = 0.2 * (salary - 500000);
      tax = tax + 12500;
      return tax;
    } else if (salary >= 1000000) {
      tax = 0.3 * (salary - 1000000);
      tax = tax + 112500;
      return tax;
    } else {
      return 0;
    }
  };

  const generateDaysofWork = (value, tax) => {
    const dayvalue = value / 365;
    const noday = tax / dayvalue;
    return Math.round(noday);
  };

  return (
    <div>
      {/* <Navbar /> */}
      <div className="pt_5rem ">
        <div className="container">
          <div className="tcenter">
            <h1 className="tcenter fs3 font-weight-bold">KITNA TAX DENA PADEGA?</h1>
            <br />
            <h3 className="tcenter fw400">Enter your Base Salary :</h3>
            <br />
            <p className="fs2">
              ₹
              <input
                type="number"
                onChange={(e) => {
                  setvalue(e.target.value);
                  let tax = generateTax(e.target.value);
                  setIncome(e.target.value - tax);
                  setTax(tax);
                  let days = generateDaysofWork(e.target.value, tax);
                  setDaysvalue(days);
                }}
                value={value}
                className="tax_inp"
              />
            </p>
            <br />
            <br />
          </div>
          <div className="tcenter taxbox">
            <br />
            <h3 className="fw400">Your TAX amount will be </h3>
            <h1 className="font-weight-bold">₹{tax}</h1>
            <br />
            <h3 className="fw400">Your reduced income now </h3>
            <h1 className="font-weight-bold">₹{income}</h1>

            {/* <h4></h4> */}
            {/* <br /> */}
            <br />
          </div>
          <p className="fs_14px">Income Tax deducations based on FY 2017-18</p>
          <br />

          <div className="tcenter">
            <h3 className="fw400">That will be about :</h3>
            <h3>{daysvalue} days of unpaid work</h3>
            <br />
          </div>
          <div className="tcenter subscribe_box">
            <h1 className="font-weight-bold">Want to know how to save that amount ?</h1>
            {/* <br /> */}
            <a href="/services">
              <button type="button" class="btn-lg btn btn-dark bg_blue">
                YES!
              </button>
            </a>
          </div>
          <br />
          <br />
          <br />
        </div>
      </div>
      <div>
        <ul>
          <li className="fs_14px">
            We tell you the money that government will take from your pockets.
          </li>
          <li className="fs_14px">This is Income Tax calculations FY 2017-18</li>
        </ul>
      </div>
      {/* <Footbr /> */}
    </div>
  );
};

export default Taxcal;
